import landingStore from '@/modules/saryahLanding/landing-store';
import layoutStore from '@/modules/layout/layout-store';


export default {
  namespaced: true,

  modules: {
    landing: landingStore,
    layout: layoutStore,
  },
};
